import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { PWAService } from './pwa.service';

export const ngxPWAServiceModule = angular.module('ngxPWAServiceModule', [])
	.factory('ngxPWAService', downgradeInjectable(PWAService))
	.name;
